export default [

     {
          path: '/tenable-auth-setup',
          name: 'TenableAuthSetup',
          component: () => import("@/views/Page/TenableAuthSetup/TenableAuthSetup.vue"),
           meta: {
               title: 'GRC | TenableAuthSetup',
          },
     }
];